module.exports = __webpack_public_path__ + "media/img/use-ico-5-52077e2cbaf4817384e470692e68ff2c.svg";